import ModalOverlay from "../../Atoms/ModalOverlay.js";
import ModalHeader from "./ModalHeader.js";
import ModalFooter from "./ModalFooter.js";
import { GrayButton, IndigoButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons.js";

const EULAModal = ({state, lang, userType, callback}) => {
     function getFormattedDate() {
          const options = { year: 'numeric', month: 'short', day: 'numeric' };
          const today = new Date();
          return today.toLocaleDateString('en-GB', options); // 'en-GB' ensures the format is Day Month, Year
        }


             const recruiterEnglish = 
<>
  Effective Date: {getFormattedDate()}
  <br /><br />

  This End User License Agreement (“Agreement”) governs your access to and use of Talnet (the “Platform”), a social and professional networking service. By using the Platform, you agree to comply with and be bound by this Agreement. If you do not agree to these terms, do not use the Platform. Talnet reserves the right to modify this Agreement at any time, and your continued use of the Platform constitutes acceptance of any modifications.

  <br /><br />
  <strong>1. Definitions</strong>
  <ul>
    <li>• “User”: Any individual or entity accessing and using the Platform.</li>
    <li>• “Profile”: A User’s personal or professional account on the Platform.</li>
    <li>• “Content”: Any information, posts, messages, images, or media uploaded, shared, or created by a User on the Platform.</li>
    <li>• “Talnet”: Refers to TalNet.Co, the owner and operator of the Platform and its affiliates.</li>
  </ul>
  <br />

  <strong>2. Account Eligibility and Responsibilities</strong>
  <ul>
    <li>• Users must be at least 16 years old or meet the age of majority in their jurisdiction. Users are responsible for maintaining the confidentiality of their account credentials and are responsible for all activity that occurs under their account.</li>
    <li>• Users agree to provide accurate and truthful information when creating a Profile. Talnet may suspend or remove accounts providing false information.</li>
  </ul>
  <br />

  <strong>3. Community Conduct</strong>
  <ul>
    <li>• Talnet promotes a respectful and inclusive environment. Hate speech, harassment, threats, or discriminatory content based on race, gender, religion, nationality, sexual orientation, disability, or other protected characteristics is strictly prohibited.</li>
    <li>• Talnet reserves the right to remove Content or suspend accounts in violation of this policy, without prior notice.</li>
  </ul>
  <br />

  <strong>4. Content Ownership and Licensing</strong>
  <ul>
    <li>• Users retain ownership of the Content they post. By posting Content, Users grant Talnet a non-exclusive, worldwide, royalty-free license to use, display, distribute, and promote such Content for the purpose of operating and improving the Platform.</li>
    <li>• Users are solely responsible for the Content they share, including accuracy and legality.</li>
  </ul>
  <br />

  <strong>5. Job/Connection Listings (if applicable)</strong>
  <ul>
    <li>• Users posting job or connection opportunities must ensure that listings are truthful, non-discriminatory, and comply with applicable laws.</li>
    <li>• Ownership and solicitation rights over applicants or contacts depend on the subscription tier (free or paid) and will be detailed in the Platform’s specific terms for those services.</li>
  </ul>
  <br />

  <strong>6. Privacy and Data Protection</strong>
  <ul>
    <li>• Talnet collects and processes personal information in accordance with its Privacy Policy. By using the Platform, Users consent to the collection, use, and storage of personal data as described in the Privacy Policy.</li>
    <li>• Users should avoid sharing sensitive personal information in public areas of the Platform.</li>
  </ul>
  <br />

  <strong>7. Limitation of Liability</strong>
  <ul>
    <li>• Talnet is not responsible for any indirect, incidental, special, or consequential damages arising from the use of the Platform, including loss of data, reputation, or income. Talnet’s total liability shall not exceed any fees paid by the User for premium services in the six months preceding a claim.</li>
  </ul>
  <br />

  <strong>8. Indemnification</strong>
  <ul>
    <li>• Users agree to indemnify and hold harmless Talnet, its affiliates, officers, and employees from any claims, damages, or losses arising from their use of the Platform or violation of this Agreement.</li>
  </ul>
  <br />

  <strong>9. Rights to Revoke or Suspend Access</strong>
  <ul>
    <li>• Talnet may suspend, restrict, or terminate any account or Content at its discretion, including violations of this Agreement, illegal activity, or threats to Platform integrity.</li>
  </ul>
  <br />

  <strong>10. Compliance with Laws</strong>
  <ul>
    <li>• Users must comply with all applicable laws and regulations when using the Platform. Talnet does not guarantee the legality of any Content and disclaims responsibility for any User violations of law.</li>
  </ul>
  <br />

  <strong>11. Modifications and Termination</strong>
  <ul>
    <li>• Talnet may modify or discontinue any feature of the Platform or this Agreement at any time. Users acknowledge that Talnet is not liable for any modification, suspension, or discontinuation.</li>
  </ul>
  <br />

  <strong>12. Governing Law and Dispute Resolution</strong>
  <ul>
    <li>• This Agreement is governed by the laws of the Province of Quebec, Canada. Any disputes shall be resolved exclusively in the courts located within Quebec.</li>
  </ul>
  <br />

  <strong>Acceptance of Terms</strong>
  <br />
  By using Talnet, you acknowledge that you have read, understood, and agree to be bound by this Agreement.
  <br /><br />

  <div className="flex space-x-2">
    <GrayButton
      caption={"I don't Accept"}
      onClick={() => {
        state.setEULAModalOpen(false);
        callback({ user_accepted_eula: false });
      }}
    />
    <TealButton
      caption={"I Accept"}
      onClick={() => {
        callback({ user_accepted_eula: true });
        state.setEULAModalOpen(false);
      }}
    />
  </div>
</>


     const recruiterFrench = 
<>
  Date d'entrée en vigueur : {getFormattedDate()}
  <br /><br />

  Le présent Contrat de Licence Utilisateur Final (« Contrat ») régit votre accès et votre utilisation de Talnet (la « Plateforme »), un service de réseau social et professionnel. En utilisant la Plateforme, vous acceptez de respecter et d’être lié par ce Contrat. Si vous n’acceptez pas ces conditions, n’utilisez pas la Plateforme. Talnet se réserve le droit de modifier ce Contrat à tout moment, et votre utilisation continue de la Plateforme constitue une acceptation de ces modifications.

  <br /><br />
  <strong>1. Définitions</strong>
  <ul>
    <li>• « Utilisateur » : Toute personne ou entité accédant et utilisant la Plateforme.</li>
    <li>• « Profil » : Le compte personnel ou professionnel d’un Utilisateur sur la Plateforme.</li>
    <li>• « Contenu » : Toute information, publication, message, image ou média téléchargé, partagé ou créé par un Utilisateur sur la Plateforme.</li>
    <li>• « Talnet » : Désigne TalNet.Co, propriétaire et opérateur de la Plateforme et de ses affiliés.</li>
  </ul>
  <br />

  <strong>2. Éligibilité et Responsabilités du Compte</strong>
  <ul>
    <li>• Les Utilisateurs doivent avoir au moins 16 ans ou l’âge de la majorité dans leur juridiction. Les Utilisateurs sont responsables de la confidentialité de leurs identifiants et de toutes les activités réalisées via leur compte.</li>
    <li>• Les Utilisateurs s’engagent à fournir des informations exactes et véridiques lors de la création d’un Profil. Talnet peut suspendre ou supprimer les comptes fournissant de fausses informations.</li>
  </ul>
  <br />

  <strong>3. Conduite au sein de la Communauté</strong>
  <ul>
    <li>• Talnet favorise un environnement respectueux et inclusif. Les discours haineux, le harcèlement, les menaces ou tout contenu discriminatoire basé sur la race, le genre, la religion, la nationalité, l’orientation sexuelle, le handicap ou toute autre caractéristique protégée sont strictement interdits.</li>
    <li>• Talnet se réserve le droit de supprimer tout Contenu ou de suspendre des comptes en violation de cette politique, sans préavis.</li>
  </ul>
  <br />

  <strong>4. Propriété et Licence du Contenu</strong>
  <ul>
    <li>• Les Utilisateurs conservent la propriété du Contenu qu’ils publient. En publiant du Contenu, les Utilisateurs accordent à Talnet une licence non exclusive, mondiale et libre de droits pour utiliser, afficher, distribuer et promouvoir ce Contenu dans le but d’exploiter et d’améliorer la Plateforme.</li>
    <li>• Les Utilisateurs sont seuls responsables du Contenu qu’ils partagent, y compris de sa véracité et de sa légalité.</li>
  </ul>
  <br />

  <strong>5. Annonces de Jobs ou de Connexions (le cas échéant)</strong>
  <ul>
    <li>• Les Utilisateurs publiant des offres d’emploi ou des opportunités de connexion doivent s’assurer que les annonces sont véridiques, non discriminatoires et conformes aux lois applicables.</li>
    <li>• Les droits de propriété et de sollicitation sur les candidats ou contacts dépendent du niveau d’abonnement (gratuit ou payant) et seront détaillés dans les conditions spécifiques de la Plateforme pour ces services.</li>
  </ul>
  <br />

  <strong>6. Confidentialité et Protection des Données</strong>
  <ul>
    <li>• Talnet collecte et traite les informations personnelles conformément à sa Politique de Confidentialité. En utilisant la Plateforme, les Utilisateurs consentent à la collecte, l’utilisation et le stockage de leurs données personnelles comme décrit dans cette Politique.</li>
    <li>• Les Utilisateurs doivent éviter de partager des informations personnelles sensibles dans les espaces publics de la Plateforme.</li>
  </ul>
  <br />

  <strong>7. Limitation de Responsabilité</strong>
  <ul>
    <li>• Talnet n’est pas responsable des dommages indirects, accessoires, spéciaux ou consécutifs résultant de l’utilisation de la Plateforme, y compris la perte de données, de réputation ou de revenus. La responsabilité totale de Talnet ne pourra excéder les frais payés par l’Utilisateur pour les services premium dans les six mois précédant une réclamation.</li>
  </ul>
  <br />

  <strong>8. Indemnisation</strong>
  <ul>
    <li>• Les Utilisateurs acceptent d’indemniser et de dégager Talnet, ses affiliés, dirigeants et employés de toute réclamation, dommage ou perte découlant de leur utilisation de la Plateforme ou de la violation de ce Contrat.</li>
  </ul>
  <br />

  <strong>9. Droits de Révoquer ou Suspendre l’Accès</strong>
  <ul>
    <li>• Talnet peut suspendre, restreindre ou résilier tout compte ou Contenu à sa discrétion, y compris pour des violations du présent Contrat, des activités illégales ou des menaces pour l’intégrité de la Plateforme.</li>
  </ul>
  <br />

  <strong>10. Conformité aux Lois</strong>
  <ul>
    <li>• Les Utilisateurs doivent se conformer à toutes les lois et réglementations applicables lors de l’utilisation de la Plateforme. Talnet ne garantit pas la légalité du Contenu et décline toute responsabilité pour les violations légales commises par les Utilisateurs.</li>
  </ul>
  <br />

  <strong>11. Modifications et Résiliation</strong>
  <ul>
    <li>• Talnet peut modifier ou interrompre toute fonctionnalité de la Plateforme ou ce Contrat à tout moment. Les Utilisateurs reconnaissent que Talnet n’est pas responsable des modifications, suspensions ou interruptions.</li>
  </ul>
  <br />

  <strong>12. Droit Applicable et Résolution des Litiges</strong>
  <ul>
    <li>• Ce Contrat est régi par les lois de la province de Québec, Canada. Tout litige sera résolu exclusivement devant les tribunaux situés au Québec.</li>
  </ul>
  <br />

  <strong>Acceptation des Conditions</strong>
  <br />
  En utilisant Talnet, vous reconnaissez avoir lu, compris et accepté d’être lié par ce Contrat.
  <br /><br />

  <div className="flex space-x-2">
    <GrayButton
      caption={"Je n'accepte pas"}
      onClick={() => {
        state.setEULAModalOpen(false);
        callback({ user_accepted_eula: false });
      }}
    />
    <TealButton
      caption={"J'accepte"}
      onClick={() => {
        callback({ user_accepted_eula: true });
        state.setEULAModalOpen(false);
      }}
    />
  </div>
</>

     const employerEnglish = 
<>
  Effective Date: {getFormattedDate()}
  <br /><br />

  This End User License Agreement (“Agreement”) governs your access to and use of Talnet (the “Platform”), a social and professional networking service. By using the Platform, you agree to comply with and be bound by this Agreement. If you do not agree to these terms, do not use the Platform. Talnet reserves the right to modify this Agreement at any time, and your continued use of the Platform constitutes acceptance of any modifications.

  <br /><br />
  <strong>1. Definitions</strong>
  <ul>
    <li>• “User”: Any individual or entity accessing and using the Platform.</li>
    <li>• “Profile”: A User’s personal or professional account on the Platform.</li>
    <li>• “Content”: Any information, posts, messages, images, or media uploaded, shared, or created by a User on the Platform.</li>
    <li>• “Talnet”: Refers to Talnet Inc., the owner and operator of the Platform and its affiliates.</li>
  </ul>
  <br />

  <strong>2. Account Eligibility and Responsibilities</strong>
  <ul>
    <li>• Users must be at least 16 years old or meet the age of majority in their jurisdiction. Users are responsible for maintaining the confidentiality of their account credentials and are responsible for all activity that occurs under their account.</li>
    <li>• Users agree to provide accurate and truthful information when creating a Profile. Talnet may suspend or remove accounts providing false information.</li>
  </ul>
  <br />

  <strong>3. Community Conduct</strong>
  <ul>
    <li>• Talnet promotes a respectful and inclusive environment. Hate speech, harassment, threats, or discriminatory content based on race, gender, religion, nationality, sexual orientation, disability, or other protected characteristics is strictly prohibited.</li>
    <li>• Talnet reserves the right to remove Content or suspend accounts in violation of this policy, without prior notice.</li>
  </ul>
  <br />

  <strong>4. Content Ownership and Licensing</strong>
  <ul>
    <li>• Users retain ownership of the Content they post. By posting Content, Users grant Talnet a non-exclusive, worldwide, royalty-free license to use, display, distribute, and promote such Content for the purpose of operating and improving the Platform.</li>
    <li>• Users are solely responsible for the Content they share, including accuracy and legality.</li>
  </ul>
  <br />

  <strong>5. Job/Connection Listings (if applicable)</strong>
  <ul>
    <li>• Employers or Users posting job or connection opportunities must ensure that listings are truthful, non-discriminatory, and comply with applicable laws.</li>
    <li>• Ownership and solicitation rights over applicants or contacts depend on the subscription tier (free or paid) and will be detailed in the Platform’s specific terms for those services.</li>
  </ul>
  <br />

  <strong>6. Privacy and Data Protection</strong>
  <ul>
    <li>• Talnet collects and processes personal information in accordance with its Privacy Policy. By using the Platform, Users consent to the collection, use, and storage of personal data as described in the Privacy Policy.</li>
    <li>• Users should avoid sharing sensitive personal information in public areas of the Platform.</li>
  </ul>
  <br />

  <strong>7. Limitation of Liability</strong>
  <ul>
    <li>• Talnet is not responsible for any indirect, incidental, special, or consequential damages arising from the use of the Platform, including loss of data, reputation, or income. Talnet’s total liability shall not exceed any fees paid by the User for premium services in the six months preceding a claim.</li>
  </ul>
  <br />

  <strong>8. Indemnification</strong>
  <ul>
    <li>• Users agree to indemnify and hold harmless Talnet, its affiliates, officers, and employees from any claims, damages, or losses arising from their use of the Platform or violation of this Agreement.</li>
  </ul>
  <br />

  <strong>9. Rights to Revoke or Suspend Access</strong>
  <ul>
    <li>• Talnet may suspend, restrict, or terminate any account or Content at its discretion, including violations of this Agreement, illegal activity, or threats to Platform integrity.</li>
  </ul>
  <br />

  <strong>10. Compliance with Laws</strong>
  <ul>
    <li>• Users must comply with all applicable laws and regulations when using the Platform. Talnet does not guarantee the legality of any Content and disclaims responsibility for any User violations of law.</li>
  </ul>
  <br />

  <strong>11. Modifications and Termination</strong>
  <ul>
    <li>• Talnet may modify or discontinue any feature of the Platform or this Agreement at any time. Users acknowledge that Talnet is not liable for any modification, suspension, or discontinuation.</li>
  </ul>
  <br />

  <strong>12. Governing Law and Dispute Resolution</strong>
  <ul>
    <li>• This Agreement is governed by the laws of the Province of Quebec, Canada. Any disputes shall be resolved exclusively in the courts located within Quebec.</li>
  </ul>
  <br />

  <strong>Acceptance of Terms</strong>
  <br />
  By using Talnet, you acknowledge that you have read, understood, and agree to be bound by this Agreement.
  <br /><br />

  <div className="flex space-x-2">
    <GrayButton
      caption={"I don't Accept"}
      onClick={() => {
        state.setEULAModalOpen(false);
        callback({ user_accepted_eula: false });
      }}
    />
    <TealButton
      caption={"I Accept"}
      onClick={() => {
        callback({ user_accepted_eula: true });
        state.setEULAModalOpen(false);
      }}
    />
  </div>
</>


     const employerFrench = 
<>
  Date d'entrée en vigueur : {getFormattedDate()}
  <br /><br />

  Le présent Contrat de Licence Utilisateur Final (« Contrat ») régit votre accès et votre utilisation de Talnet (la « Plateforme »), un service de réseau social et professionnel. En utilisant la Plateforme, vous acceptez de respecter et d’être lié par ce Contrat. Si vous n’acceptez pas ces conditions, n’utilisez pas la Plateforme. Talnet se réserve le droit de modifier ce Contrat à tout moment, et votre utilisation continue de la Plateforme constitue une acceptation de ces modifications.

  <br /><br />
  <strong>1. Définitions</strong>
  <ul>
    <li>• « Utilisateur » : Toute personne ou entité accédant et utilisant la Plateforme.</li>
    <li>• « Profil » : Le compte personnel ou professionnel d’un Utilisateur sur la Plateforme.</li>
    <li>• « Contenu » : Toute information, publication, message, image ou média téléchargé, partagé ou créé par un Utilisateur sur la Plateforme.</li>
    <li>• « Talnet » : Désigne TalNet.Co, propriétaire et opérateur de la Plateforme et de ses affiliés.</li>
  </ul>
  <br />

  <strong>2. Éligibilité et Responsabilités du Compte</strong>
  <ul>
    <li>• Les Utilisateurs doivent avoir au moins 16 ans ou l’âge de la majorité dans leur juridiction. Les Utilisateurs sont responsables de la confidentialité de leurs identifiants et de toutes les activités réalisées via leur compte.</li>
    <li>• Les Utilisateurs s’engagent à fournir des informations exactes et véridiques lors de la création d’un Profil. Talnet peut suspendre ou supprimer les comptes fournissant de fausses informations.</li>
  </ul>
  <br />

  <strong>3. Conduite au sein de la Communauté</strong>
  <ul>
    <li>• Talnet favorise un environnement respectueux et inclusif. Les discours haineux, le harcèlement, les menaces ou tout contenu discriminatoire basé sur la race, le genre, la religion, la nationalité, l’orientation sexuelle, le handicap ou toute autre caractéristique protégée sont strictement interdits.</li>
    <li>• Talnet se réserve le droit de supprimer tout Contenu ou de suspendre des comptes en violation de cette politique, sans préavis.</li>
  </ul>
  <br />

  <strong>4. Propriété et Licence du Contenu</strong>
  <ul>
    <li>• Les Utilisateurs conservent la propriété du Contenu qu’ils publient. En publiant du Contenu, les Utilisateurs accordent à Talnet une licence non exclusive, mondiale et libre de droits pour utiliser, afficher, distribuer et promouvoir ce Contenu dans le but d’exploiter et d’améliorer la Plateforme.</li>
    <li>• Les Utilisateurs sont seuls responsables du Contenu qu’ils partagent, y compris de sa véracité et de sa légalité.</li>
  </ul>
  <br />

  <strong>5. Annonces de Jobs ou de Connexions (le cas échéant)</strong>
  <ul>
    <li>• Les Utilisateurs publiant des offres d’emploi ou des opportunités de connexion doivent s’assurer que les annonces sont véridiques, non discriminatoires et conformes aux lois applicables.</li>
    <li>• Les droits de propriété et de sollicitation sur les candidats ou contacts dépendent du niveau d’abonnement (gratuit ou payant) et seront détaillés dans les conditions spécifiques de la Plateforme pour ces services.</li>
  </ul>
  <br />

  <strong>6. Confidentialité et Protection des Données</strong>
  <ul>
    <li>• Talnet collecte et traite les informations personnelles conformément à sa Politique de Confidentialité. En utilisant la Plateforme, les Utilisateurs consentent à la collecte, l’utilisation et le stockage de leurs données personnelles comme décrit dans cette Politique.</li>
    <li>• Les Utilisateurs doivent éviter de partager des informations personnelles sensibles dans les espaces publics de la Plateforme.</li>
  </ul>
  <br />

  <strong>7. Limitation de Responsabilité</strong>
  <ul>
    <li>• Talnet n’est pas responsable des dommages indirects, accessoires, spéciaux ou consécutifs résultant de l’utilisation de la Plateforme, y compris la perte de données, de réputation ou de revenus. La responsabilité totale de Talnet ne pourra excéder les frais payés par l’Utilisateur pour les services premium dans les six mois précédant une réclamation.</li>
  </ul>
  <br />

  <strong>8. Indemnisation</strong>
  <ul>
    <li>• Les Utilisateurs acceptent d’indemniser et de dégager Talnet, ses affiliés, dirigeants et employés de toute réclamation, dommage ou perte découlant de leur utilisation de la Plateforme ou de la violation de ce Contrat.</li>
  </ul>
  <br />

  <strong>9. Droits de Révoquer ou Suspendre l’Accès</strong>
  <ul>
    <li>• Talnet peut suspendre, restreindre ou résilier tout compte ou Contenu à sa discrétion, y compris pour des violations du présent Contrat, des activités illégales ou des menaces pour l’intégrité de la Plateforme.</li>
  </ul>
  <br />

  <strong>10. Conformité aux Lois</strong>
  <ul>
    <li>• Les Utilisateurs doivent se conformer à toutes les lois et réglementations applicables lors de l’utilisation de la Plateforme. Talnet ne garantit pas la légalité du Contenu et décline toute responsabilité pour les violations légales commises par les Utilisateurs.</li>
  </ul>
  <br />

  <strong>11. Modifications et Résiliation</strong>
  <ul>
    <li>• Talnet peut modifier ou interrompre toute fonctionnalité de la Plateforme ou ce Contrat à tout moment. Les Utilisateurs reconnaissent que Talnet n’est pas responsable des modifications, suspensions ou interruptions.</li>
  </ul>
  <br />

  <strong>12. Droit Applicable et Résolution des Litiges</strong>
  <ul>
    <li>• Ce Contrat est régi par les lois de la province de Québec, Canada. Tout litige sera résolu exclusivement devant les tribunaux situés au Québec.</li>
  </ul>
  <br />

  <strong>Acceptation des Conditions</strong>
  <br />
  En utilisant Talnet, vous reconnaissez avoir lu, compris et accepté d’être lié par ce Contrat.
  <br /><br />

  <div className="flex space-x-2">
    <GrayButton
      caption={"Je n'accepte pas"}
      onClick={() => {
        state.setEULAModalOpen(false);
        callback({ user_accepted_eula: false });
      }}
    />
    <TealButton
      caption={"J'accepte"}
      onClick={() => {
        callback({ user_accepted_eula: true });
        state.setEULAModalOpen(false);
      }}
    />
  </div>
</>

// to change
const candidateEnglish = <>

Effective Date: {getFormattedDate()}
<br/>
<br/>
This User Agreement (“Agreement”) governs your access to and use of the Talentive Inc. Job Portal (the “Portal”) as a candidate. By creating an account or applying to jobs through the Portal, you agree to comply with and be bound by this Agreement. If you do not agree to these terms, do not use the Portal. Talentive Inc. reserves the right to modify this Agreement at any time, and your continued use of the Portal constitutes acceptance of any modifications.
<br/>
<br/>
<strong>1. Definitions</strong>
<ul>
   <li>• "Candidate": An individual applying to jobs through the Talentive Portal.</li>
   <li>• "Employer": An organization or entity that posts job opportunities on the Talentive Portal.</li>
   <li>• "Talentive Inc.": Refers to Talentive Inc., owner and operator of the Portal, and its subsidiaries and affiliates.</li>
   <li>• "User": Any individual or entity accessing and using the Portal, including Candidates and Employers.</li>
</ul>
<br/>

<strong>2. Candidate Eligibility</strong>
<ul>
   <li>• The Portal is exclusively intended for those seeking employment opportunities in Information Technology (IT) and related fields. By creating an account or applying to positions, you represent that your intent aligns with Talentive's purpose of facilitating IT career opportunities.</li>
</ul>
<br/>

<strong>3. Hate Speech, Harassment, and Inclusion Policy</strong>
<ul>
   <li>• Talentive Inc. promotes a respectful and inclusive environment. Any hate speech, harassment, or discriminatory behavior based on race, gender, nationality, religion, disability, sexual orientation, or any protected characteristic is prohibited. Talentive Inc. reserves the right to remove accounts found violating this policy.</li>
</ul>
<br/>

<strong>4. Rights to Revoke or Suspend Access</strong>
<ul>
   <li>• Talentive Inc. reserves the right to suspend or terminate any Candidate account at any time, without prior notice, due to violations of this Agreement, inappropriate behavior, or any other action that may harm Talentive Inc., its users, or the Portal's integrity.</li>
</ul>
<br/>

<strong>5. Data Privacy and Consent</strong>
<ul>
   <li>• By using the Portal, Candidates consent to the collection, processing, and storage of personal data as outlined in Talentive Inc.'s Privacy Policy, which may be periodically updated. Talentive Inc. takes measures to protect data privacy but cannot guarantee the confidentiality of information submitted through the Portal. Users should take care when sharing sensitive data.</li>
</ul>
<br/>

<strong>6. User-Generated Content</strong>
<ul>
   <li>• Candidates are responsible for the accuracy and authenticity of the information they provide when creating profiles and applying to jobs. Talentive Inc. does not guarantee the accuracy of any content submitted by Users or conduct background checks on Employers. Talentive is not liable for any misrepresentation by other Users.</li>
</ul>
<br/>

<strong>7. Compliance with Applicable Laws</strong>
<ul>
   <li>• All Users agree to comply with local, state, national, and international laws and regulations. Candidates are responsible for ensuring that they are eligible to apply for and work in positions they pursue through the Portal.</li>
</ul>
<br/>

<strong>8. Limitations of Liability</strong>
<ul>
   <li>• Talentive Inc. is not liable for any indirect, incidental, special, or consequential damages, including lost job opportunities or employment outcomes, arising from or related to the use of the Portal. Talentive Inc.’s total liability for direct damages shall not exceed any application fees (if applicable) paid by the Candidate in the six months preceding the claim.</li>
</ul>
<br/>

<strong>9. Indemnification</strong>
<ul>
   <li>• Candidates agree to indemnify and hold harmless Talentive Inc., its officers, employees, and affiliates from any claims, liabilities, losses, or damages arising from (i) Candidate's violation of this Agreement, (ii) Candidate's infringement of any intellectual property or rights of a third party, and (iii) Candidate's use of the Portal.</li>
</ul>
<br/>

<strong>10. Modification and Termination</strong>
<ul>
   <li>• Talentive Inc. reserves the right to modify or terminate the Portal or this Agreement at any time. Talentive Inc. will not be liable to any third party for such modification, suspension, or discontinuation.</li>
</ul>
<br/>

<strong>11. Governing Law and Dispute Resolution</strong>
<ul>
   <li>• This Agreement is governed by the laws of the Province of Quebec, Canada, without regard to conflict of law principles. Any disputes arising from or related to this Agreement shall be resolved exclusively in the courts located within Quebec.</li>
</ul>
<br/>

<strong>Acceptance of Terms</strong>
<br/>
By using the Talentive Job Portal, you acknowledge that you have read, understood, and agree to be bound by this Agreement.
<br/>
<br/>
<div className="flex space-x-2">
    <GrayButton caption={"I don't accept"} onClick={() => { state.setEULAModalOpen(false) }} />
    <IndigoButton caption={"I accept"} onClick={() => { callback({ user_accepted_eula: true }); state.setEULAModalOpen(false) }} />
  </div>
</>
// to change
const candidateFrench = <>

Date d'entrée en vigueur : {getFormattedDate()}
<br/>
<br/>
Cet Accord d'utilisation (« Accord ») régit votre accès et utilisation du portail d'emploi de Talentive Inc. (le « Portail ») en tant que candidat. En créant un compte ou en postulant à des emplois via le Portail, vous acceptez de vous conformer et d'être lié par cet Accord. Si vous n'acceptez pas ces conditions, n'utilisez pas le Portail. Talentive Inc. se réserve le droit de modifier cet Accord à tout moment, et votre utilisation continue du Portail constitue une acceptation de toute modification.
<br/>
<br/>
<strong>1. Définitions</strong>
<ul>
<li>• « Candidat » : une personne postulant à des emplois via le portail Talentive.</li>
<li>• « Employeur » : une organisation ou entité publiant des offres d'emploi sur le portail Talentive.</li>
<li>• « Talentive Inc. » : désigne Talentive Inc., propriétaire et exploitant du Portail, ainsi que ses filiales et affiliés.</li>
<li>• « Utilisateur » : toute personne ou entité accédant et utilisant le Portail, y compris les candidats et les employeurs.</li>
</ul>
<br/>

<strong>2. Admissibilité des Candidats</strong>
<ul>
<li>• Le Portail est exclusivement destiné aux personnes recherchant des opportunités d'emploi dans le domaine des technologies de l'information (TI) et des secteurs connexes. En créant un compte ou en postulant à des postes, vous déclarez que votre intention est conforme à l'objectif de Talentive de faciliter les opportunités de carrière en TI.</li>
</ul>
<br/>

<strong>3. Politique de discours haineux, de harcèlement et d'inclusion</strong>
<ul>
<li>• Talentive Inc. promeut un environnement respectueux et inclusif. Tout discours haineux, harcèlement ou comportement discriminatoire basé sur la race, le sexe, la nationalité, la religion, le handicap, l'orientation sexuelle ou toute autre caractéristique protégée est interdit. Talentive Inc. se réserve le droit de supprimer les comptes violant cette politique.</li>
</ul>
<br/>

<strong>4. Droits de révoquer ou suspendre l'accès</strong>
<ul>
<li>• Talentive Inc. se réserve le droit de suspendre ou de résilier tout compte de candidat à tout moment, sans préavis, en cas de violation de cet Accord, de comportement inapproprié ou de toute autre action susceptible de nuire à Talentive Inc., à ses utilisateurs ou à l'intégrité du Portail.</li>
</ul>
<br/>

<strong>5. Confidentialité des données et consentement</strong>
<ul>
<li>• En utilisant le Portail, les candidats consentent à la collecte, au traitement et au stockage des données personnelles conformément à la Politique de confidentialité de Talentive Inc., qui peut être mise à jour périodiquement. Talentive Inc. prend des mesures pour protéger la confidentialité des données mais ne peut garantir la confidentialité des informations soumises via le Portail. Les utilisateurs doivent être prudents lors du partage de données sensibles.</li>
</ul>
<br/>

<strong>6. Contenu généré par l'utilisateur</strong>
<ul>
<li>• Les candidats sont responsables de l'exactitude et de l'authenticité des informations fournies lors de la création de profils et de la candidature à des emplois. Talentive Inc. ne garantit pas l'exactitude du contenu soumis par les utilisateurs ni ne vérifie les antécédents des employeurs. Talentive n'est pas responsable de toute fausse déclaration faite par d'autres utilisateurs.</li>
</ul>
<br/>

<strong>7. Conformité avec les lois applicables</strong>
<ul>
<li>• Tous les utilisateurs acceptent de se conformer aux lois et règlements locaux, provinciaux, nationaux et internationaux. Les candidats sont responsables de s'assurer qu'ils sont éligibles pour postuler et travailler aux postes qu'ils poursuivent via le Portail.</li>
</ul>
<br/>

<strong>8. Limites de responsabilité</strong>
<ul>
<li>• Talentive Inc. n'est pas responsable des dommages indirects, accessoires, spéciaux ou consécutifs, y compris les opportunités d'emploi manquées ou les résultats d'emploi, découlant de ou liés à l'utilisation du Portail. La responsabilité totale de Talentive Inc. pour les dommages directs ne doit pas dépasser les frais de candidature (le cas échéant) payés par le candidat dans les six mois précédant la réclamation.</li>
</ul>
<br/>

<strong>9. Indemnisation</strong>
<ul>
<li>• Les candidats acceptent d'indemniser et de dégager de toute responsabilité Talentive Inc., ses dirigeants, employés et affiliés contre toute réclamation, responsabilité, perte ou dommage découlant de (i) la violation de cet Accord par le candidat, (ii) l'infraction du candidat à toute propriété intellectuelle ou aux droits d'un tiers, et (iii) l'utilisation du Portail par le candidat.</li>
</ul>
<br/>

<strong>10. Modification et résiliation</strong>
<ul>
<li>• Talentive Inc. se réserve le droit de modifier ou de résilier le Portail ou cet Accord à tout moment. Talentive Inc. ne sera pas responsable envers un tiers pour toute modification, suspension ou interruption.</li>
</ul>
<br/>

<strong>11. Droit applicable et résolution des litiges</strong>
<ul>
<li>• Cet Accord est régi par les lois de la Province de Québec, Canada, sans égard aux principes de conflit de lois. Tout litige découlant de ou lié à cet Accord sera résolu exclusivement dans les tribunaux situés au Québec.</li>
</ul>
<br/>

<strong>Acceptation des conditions</strong>
<br/>
En utilisant le portail d'emploi Talentive, vous reconnaissez avoir lu, compris et accepté d'être lié par cet Accord.
<br/>
<br/>
<div className="flex space-x-2">
    <GrayButton caption={"Je ne suis pas d'accord"} onClick={() => { state.setEULAModalOpen(false) }} />
    <IndigoButton caption={"J'accepte"} onClick={() => { callback({ user_accepted_eula: true }); state.setEULAModalOpen(false) }} />
  </div>
</>

     return (
<div>
  <div
    className={`fixed inset-0 z-40 outline-none focus:outline-none transition-transform duration-300 ease-in-out transform ${
      state.EULAModalOpen ? 'translate-x-0' : 'translate-x-full'
    } flex justify-center items-center`}
  >
    <div className="relative w-5/6 shadow-2xl rounded-3xl sm:w-4/6 md:w-3/4 lg:w-2/4 xl:w-2/4 2xl:w-2/4 max-h-screen overflow-y-auto">
      {/* Modal Content */}
      <div className="border-4 border-gray-200 dark:border-gray-700 rounded-3xl relative flex flex-col w-full bg-white outline-none focus:outline-none dark:bg-gray-900 p-6 max-h-[75vh] overflow-y-auto">
  {/* Flex container for close button and title */}
  <div className="flex items-center">
    {/* Close Button */}
    <button 
      className="text-gray-500 dark:text-white duration-300 hover:text-gray-700 focus:outline-none mr-2"
      onClick={()=>state.setEULAModalOpen(false)} // Replace with your close function
    >
      <i className="fas fa-times"></i>
    </button>
    
    {/* Title */}
    <h2 className="text-xl font-semibold font-inter dark:text-white">
      {lang === 'fr' 
        ? "Conditions d’utilisation et accord de licence du portail d’emploi Talnet" 
        : "TalNet Job Portal Terms and License Agreement"
      }
    </h2>
  </div>
  
  <span className="mt-4 text-xs font-inter dark:text-gray-300">
    {userType === 'RECRUITER' && lang === 'fr' && recruiterFrench}
    {userType === 'RECRUITER' && lang !== 'fr' && recruiterEnglish}
    {userType === 'EMPLOYER' && lang === 'fr' && employerFrench}
    {userType === 'EMPLOYER' && lang !== 'fr' && employerEnglish}
    {userType === 'CANDIDATE' && lang === 'fr' && candidateFrench}
    {userType === 'CANDIDATE' && lang !== 'fr' && candidateEnglish}
  </span>
  {/* Other modal content */}
</div>
    </div>
  </div>
  {state.EULAModalOpen && < ModalOverlay />}
</div>
     )
}

export default EULAModal